import { usePreferences } from 'context/preferences/PreferencesContext'
import { ContactCompanyType } from 'models/contact_companies'
import { useParams } from 'react-router-dom'
import { getIdWithPrefix } from 'utils/pathUtils'
import { NewNursingHomePage } from '../new-company-pages/NewNursingHomePage'

export default function NursingHomePage() {
  const urlParams = useParams()
  const { preferences } = usePreferences()
  const nursingHomeID = urlParams?.nursinghome_id
    ? getIdWithPrefix(
        urlParams?.nursinghome_id,
        preferences?.company_type_prefix_map[ContactCompanyType.NursingHome]
      )
    : undefined

  return <NewNursingHomePage nursingHomeID={nursingHomeID} />
}
